import React from "react";
import {graphql} from "gatsby";

import SEO from "../components/seo";
import Header from '../components/Header/Header';
import SectionWrapper from '../components/SectionWrapper/SectionWrapper';


// Tu mozliwe ze beda filmiki a nie wideo 

const Naglosnienie = ({data}) => { 
  const naglosnienie = data.naglosnienie.childImageSharp.fluid;
  const oswietlenie = data.oswietlenie.childImageSharp.fluid;
  const multimedia = data.multimedia.childImageSharp.fluid;

  const paragraphText = "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et";

  const titleText = "Nagłośnienie i oświetlenie";
  const bglink = data.bg.childImageSharp.fluid;

  const content = [
    {
      title: "Nagłośnienie",
      text: "W naszej ofercie posiadamy pełne zaplecze techniczne umożliwiające obsługę techniczną na weselach dla zespołów wieloinstrumentalnych, jak również dla duetów i małych zespołów muzycznych. Organizujemy oprawę muzyczną zarówno w salach weselnych jak i pięknych oklicznościach przyrody w niekonwencjonalnych miejscach. Posiadamy: estetyczne konstrukcje sceniczne, nagłośnienie dopasowane do miejca oraz niezawodny sprzęt do kontroli naszych profesjonalnych systemów audio. Używamy tylko sprzętu najwyższej klasy.",
      image: naglosnienie,
      alt: "Nagłośnienie",
      link: "https://vimeo.com/292831256",
      target: "yes"
    },
    {
      title: "Oświetlenie", 
      text: "Prawdziwy klimat budują światła. To one zapewniają prawdziwą dyskotekową, imprezową oprawę wizualną na każdej zabawie tanecznej. Posiadamy sprzęt oświetleniowy najwyżej klasy, który może działać zarówno automatycznie jak i z pełną obsługą profesjonalnego realizatora światła. W naszej ofercie zapewniamy również usługę tworzenia wizualizacji w technologii mappingu, niekonwencjonalne pokazy laserowe oraz możliwość odtworzenia filmów.",
      image: oswietlenie,
      alt: "Oświetlenie",
      link: "https://vimeo.com/294791417",
      target: "yes"
    },
    {
      title: "Multimedia", 
      text: "W naszej ofercie znajdą Państwo również nikonwencjonalne rozwiązania oprawy sceny. Tyczy się to wynajmu ekranów ledowych, czy rzutników z ekranami w celu odtworzenia filmów, prezentacji zdjęć czy teledysków video z pomocą naszego doświadczonego vj’a. Efekty multimedialne zapewnią niecodzienne wrażenia na Państwa weselu i jeszcze bardziej podniosą wrażenia wizualne Państwa wyjątkowego dnia",
      image: multimedia,
      alt: "Multimedia",
      link: "https://vimeo.com/326299070",
      target: "yes"
    },
  ];

  return (
    <>
      <SEO title="Nagłośnienie na wesele"/>
      <Header link={bglink}/>
      <SectionWrapper content={content} title={titleText} text={paragraphText} resize="yes"/>
    </>
  )
}

export const query = graphql`
  {
    naglosnienie: file(name: {eq: "naglosnienie2"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    oswietlenie: file(name: {eq: "oswietlenie"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    multimedia: file(name: {eq: "multimedia1"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    bg: file(name: {eq: "naglosnienie_bg"}) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;

export default Naglosnienie